export default __webpack_public_path__ + "static/media/823.b236457c.png";